module.exports = __webpack_public_path__ + "img/lander-cover.df2be635.jpg";